import React from 'react'

export const HeroBottomMask: React.FC = () => {
  return (
    <>
      <div
        id="slider-bottom-image-container"
        className="absolute -bottom-px left-0 w-full h-[3.75rem] z-[2] hero-bottom-mask"
      />
    </>
  )
}
